import FormValidationMixin from '@/components/mixins/form-validation-mixin'

export default {
  name: 'adminUserInvite',
  inject: [
    '$currentUser',
    '$signedInUserInfo',
    '$utils',
    '$api',
    '$apiError'
  ],
  components: {},
  props: {
    showUserFormProp: {
      type: Boolean,
      default () { return false }
    }
  },
  watch: {
    showUserFormProp (newVal) {
      this.showUserForm = newVal
      this.userForm = {}
    },
    userForm (newVal) {
      if (newVal.firstName) newVal.firstName.trim()
      if (newVal.lastName) newVal.lastName.trim()
      this.userForm = newVal
    }
  },
  mixins: [FormValidationMixin],
  data () {
    const validateName = (rule, value, callback) => {
      if (rule.field === 'firstName') {
        if (value.trim().length <= 0) return callback(new Error(this.$t('label.requiredFirstName')))
      }

      if (rule.field === 'lastName') {
        if (value.trim().length <= 0) return callback(new Error(this.$t('label.requiredLastName')))
      }

      callback()
    }
    return {
      error: '',
      optionProperties: [
        {
          id: 'firstName',
          name: this.$t('label.firstName')
        },
        {
          id: 'lastName',
          name: this.$t('label.lastName', 1)
        },
        {
          id: 'email',
          name: this.$t('label.email')
        }
      ],
      userForm: {},
      userFormRules: {
        email: [
          { required: true, message: this.$t('label.requiredEmail') },
          {
            type: 'email',
            message: this.$t('label.invalidEmail'),
            trigger: ['blur'],
          },
        ],
        firstName: [
          { required: true, message: this.$t('label.requiredFirstName') },
          { validator: validateName, trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: this.$t('label.requiredLastName') },
          { validator: validateName, trigger: 'blur' }
        ]
      },
      showErrorOnTopOfDialog: false,
      dialogErrorMessage: '',
      showUserForm: false,
      enableCreateNewUser: this.$currentUser.hasGroupExtended() && !this.$signedInUserInfo?.activePlan?.suspended
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('admin-menu-change', { action, payload: { data } })
      }
    },
    handleCloseInviteUserForm () {
      this.showUserForm = false
      this.userForm = {}
      this.dialogErrorMessage = ''
      this.$emit('close-invite-user-form')
    },
    handleUserFormSubmit () {
      const formEl = $(this.$refs.userForm.$el)
      formEl.find('.el-form-item').removeClass('animated shake')

      this.$refs.userForm.validate((isFormValid) => {
        if (isFormValid) {
          const createNewUserRequest = () => {
            const payload = this.$utils.clone(this.userForm)

            payload.username = payload.email
            delete payload.email

            this.$utils.mainLoader(true)

            this.$api.post(`${CONFIG.API_BASE_URL}/group/users`, payload)
              .then(response => {
                this.emitEvent('NEW_USER_CREATED', {})
                this.handleCloseInviteUserForm()
              })
              .catch((error) => {
                let errorCode = ''
                let errorMessage = ''

                if (error.response && error.response.data) {
                  errorCode = error.response.data.code ?? error.response.data.name
                  errorMessage = error.response.data.message ?? error.response.data.description
                }

                const formInptEl = (cName) => {
                  return formEl.find(cName).removeClass('is-success is-error')
                }
                formInptEl('.el-form-item').removeClass('is-error is-error-api cstm-txtcolor-white cstm-txtcolor-red')

                let showErrorOnTopOfDialog = true
                let dialogErrorMessage = null

                switch (errorCode) {
                  case 'UsernameExistsException': {
                    this.error = errorMessage
                    this.$utils.animate(formInptEl('.email').addClass('is-error-api'), 'animated shake')
                    showErrorOnTopOfDialog = false
                    break
                  }
                  case 'InvalidParameterException': {
                    this.error = errorMessage
                    showErrorOnTopOfDialog = false
                    const includesEmail = (errorMessage) => { return errorMessage.toLowerCase().includes('username') || errorMessage.toLowerCase().includes('email') }
                    const lowerStringError = errorMessage.toLowerCase()
                    let animateField = []

                    if (includesEmail(errorMessage)) {
                      this.error = this.$t('label.invalidEmail')
                      animateField = ['.email']
                    }

                    if (includesEmail(errorMessage) && lowerStringError.includes('address format')) {
                      this.error = this.$t('label.invalidEmail')
                      animateField = ['.email']
                      showErrorOnTopOfDialog = true
                      dialogErrorMessage = this.error
                    }

                    // Shake field
                    animateField.forEach((classN) => { this.$utils.animate(formInptEl(classN).addClass('is-error-api'), 'animated shake') })
                    break
                  }
                  case 'UserExistsError': {
                    this.error = this.$t('label.createUserExistErrorMessage', { email: payload.username })
                    showErrorOnTopOfDialog = true
                    dialogErrorMessage = this.error
                    break
                  }
                  case 'ExceededAllowableUsersError': {
                    this.error = this.$t('label.createUserLimitReached')
                    showErrorOnTopOfDialog = true
                    dialogErrorMessage = this.error
                    break
                  }
                  default: {
                    this.error = error.message
                    showErrorOnTopOfDialog = true
                  }
                }

                this.$utils.mainLoader(false)
                this.dialogErrorMessage = dialogErrorMessage
                this.showErrorOnTopOfDialog = showErrorOnTopOfDialog
                this.$apiError.handleAPIRequestError(error, { originalRequest: () => { createNewUserRequest() }, showDialogNotification: false })
              })
          }
          createNewUserRequest()
        } else {
          // Animate error fields
          formEl.find('input').each((indx, inpt) => {
            const inputEl = $(inpt)
            if ((inputEl.val().length < 1) || ($(inputEl.parents()[2]).hasClass('is-error'))) {
              const el = $(inputEl).parents()[2]
              window.setTimeout(() => { this.$utils.animate(el, 'animated shake') }, 1)
            }
          })
          return false
        }
      })
    }
  },
  mounted () {
  }
}
